import axios from "@/utils/axiosHelper";
// 初始化数据(含授权)
export const onGetInitDataAPI = params => {
  return axios(
    { url: "/cherry/game/info/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 提交信息
export const submitInfoApi = params => {
  return axios(
    { url: "/cherry/game/info/address", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 免密登录
export const secretFreeLoginApi = params => {
  return axios(
    { url: "/cherry/game/info/join", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/sakura/shake/api.js